export const handleNewRequestStatus = (data, newStatus, oldStatus) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();

    const toFirestore = {
      status: newStatus,
    };
    const currentTime = firebase.firestore.Timestamp.fromDate(new Date());

    const athleteUid = data.id;
    const athleteUrl =
      data.fname.toLowerCase() +
      data.lname.charAt(0).toUpperCase() +
      data.lname.slice(1).toLowerCase();

    let existingData = null;
    let existingAthleteAwardsHonors = null;
    let existingAthleteCoaches = null;
    let existingAthleteExtras = null;
    let existingAthleteImages = null;
    let existingAthleteHighSchoolSchedule = null;
    let existingAthleteSocialMedia = null;
    let existingAthleteVideo = null;

    if (oldStatus !== true && newStatus !== null && newStatus !== false) {
      const urladminRef = firestore.collection("adminAthletes").doc(athleteUid);
      const urlAwardRef = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("awardsHonors");
      const urlCoachesRef = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("coaches");
      const urlExtrasRef = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("extras");
      const urlScheduleRef = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("highschoolschedule");
      const urlSocialRef = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("socialMedia");
      const urlVideoRef = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("video");
      const urlImagesRef = firestore
        .collection("adminAthletes")
        .doc(athleteUid)
        .collection("profile")
        .doc("images");

      urladminRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            existingData = doc.data();
          } else existingData = null;

          let athleteInfo = {
            id: data.id,
            customUrl: athleteUrl,
            class: data.classYear,
            sport: data.sport,
            firstName: data.fname,
            lastName: data.lname,
            clubTeamName: data.travelTeam,
            parentTwoFirstName: data.motherName,
            parentOneFirstName: data.fatherName,
            highSchoolName: data.school,
            primaryPosition: data.primaryPosition,
            primaryPositionFilter: data.primaryPosition,
            secondaryPosition: data.secondaryPosition,
            hometown: data.resides,

            act: existingData ? existingData.act : 0,
            bats: existingData ? existingData.bats : "",
            throws: existingData ? existingData.throws : "",
            specialtyMetrics: existingData ? existingData.specialtyMetrics : "",
            classRank: existingData ? existingData.classRank : "",
            clubName: existingData ? existingData.clubName : "",

            committed: existingData ? existingData.committed : false,
            parentTwoLastName: existingData
              ? existingData.parentTwoLastName
              : "",
            parentOneLastName: existingData
              ? existingData.parentOneLastName
              : "",
            height: existingData ? existingData.height : "",
            weight: existingData ? existingData.weight : 0,
            gpa: existingData ? existingData.gpa : 0,
            highSchoolCityState: existingData
              ? existingData.highSchoolCityState
              : "",
            intendedMajor: existingData ? existingData.intendedMajor : "",
            jersey: existingData ? existingData.jersey : "",
            ncaaId: existingData ? existingData.ncaaId : 0,
            profilePublic: true,
            sat: existingData ? existingData.sat : 0,
            thumbnail: existingData ? existingData.thumbnail : "None",
          };
          const Adminbatch = firestore.batch();
          const addToAdmin = firestore.collection("adminAthletes").doc(data.id);
          const addToAthletes = firestore
            .collection("athletes")
            .doc(athleteUrl);

          Adminbatch.set(addToAdmin, athleteInfo);
          Adminbatch.set(addToAthletes, athleteInfo);
          Adminbatch.commit();
        })
        .catch((e) => console.log("Error : ", e));
      urlAwardRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            existingAthleteAwardsHonors = doc.data();
          } else existingAthleteAwardsHonors = null;

          let athleteAwardsHonors = {
            academicHonorOne: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.academicHonorOne
              : "",
            academicHonorTwo: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.academicHonorTwo
              : "",
            academicHonorThree: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.academicHonorThree
              : "",
            academicHonorFour: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.academicHonorFour
              : "",
            academicHonorFive: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.academicHonorFive
              : "",
            academicHonorSix: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.academicHonorSix
              : "",
            academicHonorSeven: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.academicHonorSeven
              : "",
            academicHonorEight: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.academicHonorEight
              : "",
            academicHonorNine: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.academicHonorNine
              : "",
            academicHonorTen: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.academicHonorTen
              : "",
            athleticAwardOne: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.athleticAwardOne
              : "",
            athleticAwardTwo: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.athleticAwardTwo
              : "",
            athleticAwardThree: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.athleticAwardThree
              : "",
            athleticAwardFour: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.athleticAwardFour
              : "",
            athleticAwardFive: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.athleticAwardFive
              : "",
            athleticAwardSix: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.athleticAwardSix
              : "",
            athleticAwardSeven: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.athleticAwardSeven
              : "",
            athleticAwardEight: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.athleticAwardEight
              : "",
            athleticAwardNine: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.athleticAwardNine
              : "",
            athleticAwardTen: existingAthleteAwardsHonors
              ? existingAthleteAwardsHonors.athleticAwardTen
              : "",
          };
          const Awardbatch = firestore.batch();

          const addToAdminAwardsHonors = firestore
            .collection("adminAthletes")
            .doc(athleteUid)
            .collection("profile")
            .doc("awardsHonors");
          const addToAwardsHonors = firestore
            .collection("athletes")
            .doc(athleteUrl)
            .collection("profile")
            .doc("awardsHonors");

          Awardbatch.set(addToAwardsHonors, athleteAwardsHonors);
          Awardbatch.set(addToAdminAwardsHonors, athleteAwardsHonors);
          Awardbatch.commit();
        })
        .catch((e) => console.log("Error : ", e));
      urlCoachesRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            existingAthleteCoaches = doc.data();
          } else existingAthleteCoaches = null;

          let athleteCoaches = {
            clubCoachEmail: existingAthleteCoaches
              ? existingAthleteCoaches.clubCoachEmail
              : "",
            clubCoachName: existingAthleteCoaches
              ? existingAthleteCoaches.clubCoachName
              : "",
            clubCoachPhone: existingAthleteCoaches
              ? existingAthleteCoaches.clubCoachPhone
              : "",
            highSchoolCoachEmail: existingAthleteCoaches
              ? existingAthleteCoaches.highSchoolCoachEmail
              : "",
            highSchoolCoachName: existingAthleteCoaches
              ? existingAthleteCoaches.highSchoolCoachName
              : "",
            highSchoolCoachPhone: existingAthleteCoaches
              ? existingAthleteCoaches.highSchoolCoachPhone
              : "",
            hittingCoachEmail: existingAthleteCoaches
              ? existingAthleteCoaches.hittingCoachEmail
              : "",
            hittingCoachName: existingAthleteCoaches
              ? existingAthleteCoaches.hittingCoachName
              : "",
            hittingCoachPhone: existingAthleteCoaches
              ? existingAthleteCoaches.hittingCoachPhone
              : "",
            pitchingCoachEmail: existingAthleteCoaches
              ? existingAthleteCoaches.pitchingCoachEmail
              : "",
            pitchingCoachName: existingAthleteCoaches
              ? existingAthleteCoaches.pitchingCoachName
              : "",
            pitchingCoachPhone: existingAthleteCoaches
              ? existingAthleteCoaches.pitchingCoachPhone
              : "",
          };
          const Coachbatch = firestore.batch();

          const addToAdminCoaches = firestore
            .collection("adminAthletes")
            .doc(athleteUid)
            .collection("profile")
            .doc("coaches");
          const addToCoaches = firestore
            .collection("athletes")
            .doc(athleteUrl)
            .collection("profile")
            .doc("coaches");
          Coachbatch.set(addToAdminCoaches, athleteCoaches);
          Coachbatch.set(addToCoaches, athleteCoaches);

          Coachbatch.commit();
        })
        .catch((e) => console.log("Error : ", e));
      urlExtrasRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            existingAthleteExtras = doc.data();
          } else existingAthleteExtras = null;

          let athleteExtras = {
            extraOne: existingAthleteExtras
              ? existingAthleteExtras.extraOne
              : "",
            extraTwo: existingAthleteExtras
              ? existingAthleteExtras.extraTwo
              : "",
            extraThree: existingAthleteExtras
              ? existingAthleteExtras.extraThree
              : "",
            extraFour: existingAthleteExtras
              ? existingAthleteExtras.extraFour
              : "",
            extraFive: existingAthleteExtras
              ? existingAthleteExtras.extraFive
              : "",
            hobbyOne: existingAthleteExtras
              ? existingAthleteExtras.hobbyOne
              : "",
            hobbyTwo: existingAthleteExtras
              ? existingAthleteExtras.hobbyTwo
              : "",
            hobbyThree: existingAthleteExtras
              ? existingAthleteExtras.hobbyThree
              : "",
            hobbyFour: existingAthleteExtras
              ? existingAthleteExtras.hobbyFour
              : "",
            hobbyFive: existingAthleteExtras
              ? existingAthleteExtras.hobbyFive
              : "",
            strengthOne: existingAthleteExtras
              ? existingAthleteExtras.strengthOne
              : "",
            strengthTwo: existingAthleteExtras
              ? existingAthleteExtras.strengthTwo
              : "",
            strengthThree: existingAthleteExtras
              ? existingAthleteExtras.strengthThree
              : "",
            strengthFour: existingAthleteExtras
              ? existingAthleteExtras.strengthFour
              : "",
            strengthFive: existingAthleteExtras
              ? existingAthleteExtras.strengthFive
              : "",
          };
          const Extrasbatch = firestore.batch();

          const addToAdminExtras = firestore
            .collection("adminAthletes")
            .doc(athleteUid)
            .collection("profile")
            .doc("extras");
          const addToExtras = firestore
            .collection("athletes")
            .doc(athleteUrl)
            .collection("profile")
            .doc("extras");
          Extrasbatch.set(addToAdminExtras, athleteExtras);
          Extrasbatch.set(addToExtras, athleteExtras);
          Extrasbatch.commit();
        })
        .catch((e) => console.log("Error : ", e));
      urlScheduleRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            existingAthleteHighSchoolSchedule = doc.data();
          } else existingAthleteHighSchoolSchedule = null;

          let athleteHighSchoolSchedule = {
            imageHighSchoolOne: existingAthleteHighSchoolSchedule
              ? existingAthleteHighSchoolSchedule.imageHighSchoolOne
              : "None",
            imageHighSchoolTwo: existingAthleteHighSchoolSchedule
              ? existingAthleteHighSchoolSchedule.imageHighSchoolTwo
              : "None",
            imageHighSchoolThree: existingAthleteHighSchoolSchedule
              ? existingAthleteHighSchoolSchedule.imageHighSchoolThree
              : "None",
            imageHighSchoolFour: existingAthleteHighSchoolSchedule
              ? existingAthleteHighSchoolSchedule.imageHighSchoolFour
              : "None",
            imageHighSchoolFive: existingAthleteHighSchoolSchedule
              ? existingAthleteHighSchoolSchedule.imageHighSchoolFive
              : "None",
          };
          const Extrasbatch = firestore.batch();

          const addToAdminHighSchoolImages = firestore
            .collection("adminAthletes")
            .doc(athleteUid)
            .collection("profile")
            .doc("highschoolschedule");
          Extrasbatch.set(
            addToAdminHighSchoolImages,
            athleteHighSchoolSchedule
          );
          const addToHighSchoolImages = firestore
            .collection("athletes")
            .doc(athleteUrl)
            .collection("profile")
            .doc("images");
          Extrasbatch.set(addToHighSchoolImages, athleteHighSchoolSchedule);

          Extrasbatch.commit();
        })
        .catch((e) => console.log("Error : ", e));
      urlSocialRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            existingAthleteSocialMedia = doc.data();
          } else existingAthleteSocialMedia = null;

          let athleteSocialMedia = {
            agl: existingAthleteSocialMedia
              ? existingAthleteSocialMedia.agl
              : "",
            facebook: existingAthleteSocialMedia
              ? existingAthleteSocialMedia.facebook
              : "",
            hudl: existingAthleteSocialMedia
              ? existingAthleteSocialMedia.hudl
              : "",
            instagram: existingAthleteSocialMedia
              ? existingAthleteSocialMedia.instagram
              : "",
            twitter: existingAthleteSocialMedia
              ? existingAthleteSocialMedia.twitter
              : "",
            youTube: existingAthleteSocialMedia
              ? existingAthleteSocialMedia.youTube
              : "",
          };

          const SocialBatch = firestore.batch();

          const addToAdminSocialMedia = firestore
            .collection("adminAthletes")
            .doc(athleteUid)
            .collection("profile")
            .doc("socialMedia");
          const addToSocialMedia = firestore
            .collection("athletes")
            .doc(athleteUrl)
            .collection("profile")
            .doc("socialMedia");

          SocialBatch.set(addToAdminSocialMedia, athleteSocialMedia);
          SocialBatch.set(addToSocialMedia, athleteSocialMedia);
          SocialBatch.commit();
        })
        .catch((e) => console.log("Error : ", e));
      urlVideoRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            existingAthleteVideo = doc.data();
          } else existingAthleteVideo = null;

          let athleteVideo = {
            videoOne: existingAthleteVideo
              ? existingAthleteVideo.videoOne
              : "None",
            videoTwo: existingAthleteVideo
              ? existingAthleteVideo.videoTwo
              : "None",
            videoThree: existingAthleteVideo
              ? existingAthleteVideo.videoThree
              : "None",
            videoFour: existingAthleteVideo
              ? existingAthleteVideo.videoFour
              : "None",
          };

          const VideoBatch = firestore.batch();

          const addToAdminVideo = firestore
            .collection("adminAthletes")
            .doc(athleteUid)
            .collection("profile")
            .doc("video");
          const addToVideo = firestore
            .collection("athletes")
            .doc(athleteUrl)
            .collection("profile")
            .doc("video");

          VideoBatch.set(addToAdminVideo, athleteVideo);
          VideoBatch.set(addToVideo, athleteVideo);
          VideoBatch.commit();
        })
        .catch((e) => console.log("Error : ", e));
      urlImagesRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            existingAthleteImages = doc.data();
          } else existingAthleteImages = null;

          let athleteImages = {
            imageOne: existingAthleteImages
              ? existingAthleteImages.imageOne
              : "None",
            imageTwo: existingAthleteImages
              ? existingAthleteImages.imageTwo
              : "None",
            imageThree: existingAthleteImages
              ? existingAthleteImages.imageThree
              : "None",
            imageFour: existingAthleteImages
              ? existingAthleteImages.imageFour
              : "None",
            imageFive: existingAthleteImages
              ? existingAthleteImages.imageFive
              : "None",
          };
          const ImagesBatch = firestore.batch();
          const addToAdminImages = firestore
            .collection("adminAthletes")
            .doc(athleteUid)
            .collection("profile")
            .doc("images");
          ImagesBatch.set(addToAdminImages, athleteImages);

          const addToImages = firestore
            .collection("athletes")
            .doc(athleteUrl)
            .collection("profile")
            .doc("images");
          ImagesBatch.set(addToImages, athleteImages);
          ImagesBatch.commit();
        })
        .catch((e) => console.log("Error : ", e));

      const archiveRef = firestore
        .collection("testAthleteArchive")
        .doc(athleteUid);
      archiveRef.get().then((doc) => {
        if (doc.exists) {
          archiveRef.delete();
        }
      });

      let userInfo = {
        id: data.id,
        email: data.email,
        firstName: data.fname,
        lastName: data.lname,
        customUrl: athleteUrl,
        sport: data.sport,
        advocate: data.advocate,
      };

      const addToUsers = firestore.collection("testUsers").doc(data.id);
      const role = { role: null, createdAt: currentTime };
      const roleRef = firestore.collection("userRole").doc(athleteUid);
      const newRequestRef = firestore
        .collection("testNewRequests")
        .doc(data.id);

      const batch = firestore.batch();
      batch.set(addToUsers, userInfo, { merge: true });
      batch.set(newRequestRef, toFirestore, { merge: true });
      batch.set(roleRef, { ...role, userUID: athleteUid }, { merge: true });
      batch
        .commit()
        .then(() => {
          dispatch({ type: "ADD_ATHLETE_SUCCESS" });
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
          dispatch({ type: "ADD_ATHLETE_ERROR", error });
        });
    } else {
      const urlRef = firestore.collection("testUsers").doc(athleteUid);
      urlRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            const athleteUrl = doc.data().customUrl;

            const batch = firestore.batch();

            const athleteRef = firestore.collection("athletes").doc(athleteUrl);

            batch.update(athleteRef, { profilePublic: false });

            const athleteAdminRef = firestore
              .collection("adminAthletes")
              .doc(athleteUid);
            batch.update(athleteAdminRef, { profilePublic: false });

            const archiveRef = firestore
              .collection("testAthleteArchive")
              .doc(athleteUid);
            batch.set(
              archiveRef,
              { archiveDate: currentTime },
              { merge: true }
            );
            const newRequestRef = firestore
              .collection("testNewRequests")
              .doc(data.id);

            batch.set(newRequestRef, toFirestore, { merge: true });

            const role = { role: "newUser", createdAt: currentTime };
            const roleRef = firestore.collection("userRole").doc(athleteUid);
            batch.set(
              roleRef,
              { ...role, userUID: athleteUid },
              { merge: true }
            );

            batch
              .commit()
              .then(() => {
                dispatch({ type: "DELETE_ATHLETE_SUCCESS" });
              })
              .catch((error) =>
                dispatch({ type: "DELETE_ATHLETE_ERROR", error })
              );
          } else {
          }
        })
        .catch((error) => {});
    }
  };
};
